export const SEARCH_SOURCE = 'brand_homepage';
